/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Fachliche_Fragen20Inputs */

const en__field_enum_icsrm_fachliche_fragen20 = /** @type {(inputs: _Field_Enum_Icsrm_Fachliche_Fragen20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`technical questions`)
};

const de__field_enum_icsrm_fachliche_fragen20 = /** @type {(inputs: _Field_Enum_Icsrm_Fachliche_Fragen20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachliche Fragen klären`)
};

/**
* | output |
* | --- |
* | "technical questions" |
*
* @param {_Field_Enum_Icsrm_Fachliche_Fragen20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_fachliche_fragen20 = /** @type {((inputs?: _Field_Enum_Icsrm_Fachliche_Fragen20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Fachliche_Fragen20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_fachliche_fragen20(inputs)
	return de__field_enum_icsrm_fachliche_fragen20(inputs)
});
export { _field_enum_icsrm_fachliche_fragen20 as "_field_enum_ICSRM_FACHLICHE_FRAGEN" }